import React from 'react';
interface ConnectionBadgeProps {
  status: 'live' | 'mock' | 'error' | 'loading';
  label?: string;
}
export function ConnectionBadge({
  status,
  label
}: ConnectionBadgeProps) {
  const config = {
    live: {
      dot: 'bg-emerald-500',
      text: 'text-emerald-700',
      bg: 'bg-emerald-50 border-emerald-200',
      label: label ?? 'Live data'
    },
    mock: {
      dot: 'bg-amber-500',
      text: 'text-amber-700',
      bg: 'bg-amber-50 border-amber-200',
      label: label ?? 'Mock data'
    },
    error: {
      dot: 'bg-red-500',
      text: 'text-red-700',
      bg: 'bg-red-50 border-red-200',
      label: label ?? 'Verbindingsfout'
    },
    loading: {
      dot: 'bg-blue-500 animate-pulse',
      text: 'text-blue-700',
      bg: 'bg-blue-50 border-blue-200',
      label: label ?? 'Laden...'
    }
  }[status];
  return <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${config.bg} ${config.text}`} data-id="element-5259">
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`} data-id="element-5260" />
      {config.label}
    </span>;
}